import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import {
  groupContentFields,
  groupPrivacyStatusDesc,
  grpBannerImg,
  groupRoleAlerts,
  groupRolePriviledge,
  groupERGcategories,
} from "../../../utils/constants";
import { toolkitCategories } from "../../../utils/categories";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import Select from "react-select";
import InviteMembers from "./InviteMembers";
import AddMember from "../../../components/AddToGroup/AddMember";
import GroupSettings from "./GroupSettings";
import moment from "moment";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import AddToGroupBtn from "../../../components/AddToEvent/AddToGroupBtn";
import { takeRight } from "lodash";
import { BiArrowBack, BiCog, BiInfoCircle, BiX } from "react-icons/bi";
import { isMobile } from "../../../utils/deviceInfo";
import GroupInfoMobileUI from "./GroupInfoMobileUI";

class SingleGroupHeaderMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      privacy: null,
      currentRole: this.props.currentRole,
      description: "",
      preventCreate: false,
      invitedUsers: [],
      isOpen: false,
      users: [],
      isGroupArchived: false,
      groupArchiveModal: false,
      members: this.props.members,
      group: this.props.group,
      searchedUser: "",
      removeUsers: [],
      showGrpMenu: false,
      groupLength: this.props.group.members.length,
      isSettingsUpdate: this.props.isSettingsUpdate,
      mobileOptionsDrawerOpen: false,
      mobileGroupInfoModalOpen: false,
    };
  }

  toggleMobileOptionsDrawer = () => {
    this.setState({
      mobileOptionsDrawerOpen: !this.state.mobileOptionsDrawerOpen,
    });
  };

  toggleMobileGroupInfoModal = () => {
    this.setState({
      mobileGroupInfoModalOpen: !this.state.mobileGroupInfoModalOpen,
    });
  };

  componentDidMount() {
    let { pathname } = this.props.location;
    let { organizationId } = this.props.user.profile;
    let url = `/home/groups/${organizationId._id}/settings/${this.props.group._id}`;
    if (pathname == url) {
      this.setState({ showGrpMenu: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let { members } = this.props;
    // console.log('this.props----', this.props)
    // console.log('this.prevState---- ', prevState)
    // console.log('prevProps--- ', prevProps)
    if (prevProps.members.length != members.length) {
      this.setState({ groupLength: members.length });
    }

    if (prevProps.isSettingsUpdate != this.props.isSettingsUpdate) {
      this.setState({
        bannerImg: this.props.group.bannerImg,
        name: this.props.group.name,
        privacy: this.props.group.privacy,
        group: {
          ...this.state.group,
          bannerImg: this.props.group.bannerImg,
          name: this.props.group.name,
          privacy: this.props.group.privacy,
        },
      });
    }
  }

  isGrpSettings = () => {
    let { pathname } = this.props.location;
    let { organizationId } = this.props.user.profile;
    let url = `/home/groups/${organizationId._id}/settings/${this.props.group._id}`;
    if (pathname == url) {
      this.setState({ showGrpMenu: true });
    }
  };

  getInitials = user => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  closeGroupModal = () => {
    this.setState({ isOpen: false });
  };

  checkUrl = () => {
    let { organizationId } = this.props.user.profile;
    let { history } = this.props;
    let { group } = this.state;
    let current =
      history && history.location && history.location.pathname
        ? history.location.pathname
        : "";

    if (group) {
      // console.log(current)
      let url = `/home/groups/${organizationId._id}/view/${group._id}/settings`;

      if (current == url) {
        return true;
      } else {
        return false;
      }
    }
  };

  changeMemberLength = members => {
    console.log("grp_meu ---", members);
    this.props.updateGroupMembers(members);
  };

  toGroupList = () => {
    let { organizationId } = this.props.user.profile;
    this.props.history.push(`/home/groups/${organizationId._id}/discover`);
  };

  createGroupEvent = () => {
    const { group } = this.props;
    const result = {
      groupEvent: {
        name: group.name,
        groupId: group._id,
      },
    };

    const mappedCategory = toolkitCategories.filter(
      e => e.link == "conferences-events"
    )[0];
    this.props.onProfileUpdate(result);
    this.props.history.push({
      pathname: `/home/toolkit/${group._id}/conferences-events/add`,
      // pathname:`/home/toolkit/conferences-events/events`,
      state: {
        category: mappedCategory.name,
      },
    });
  };

  changeGroupRole = val => {
    this.setState({ currentRole: val });
    this.props.changeGroupRole(val);
  };

  incrementMemberCount = val => {
    let { memberCount } = this.state;
    memberCount = memberCount + val;
    this.setState({ memberCount });
  };

  grpHomePage = () => {
    let { organizationId } = this.props.user.profile;
    let url = `/home/groups/${organizationId._id}/view/${this.state.group._id}`;
    this.props.history.push(url);
  };

  goToMembersPage = () => {
    let url = `/home/groups/${this.props.user.profile.organizationId._id}/view/${this.state.group._id}/members`;
    this.props.history.push(url);
  };

  showArchiveGroupModal = () => {
    this.setState({
      preventCreate: false,
      groupArchiveModal: !this.state.groupArchiveModal,
      isGroupArchived: false,
    });
  };

  handleArchiveGroup = () => {
    this.setState({ preventCreate: true });
    let { group } = this.state;
    let that = this;
    let isArchived = group.isArchived != true ? true : false;
    axios
      .post(url.archiveSingleGroup, {
        groupId: group._id,
        isArchived,
        orgId: group.organizationId,
      })
      .then(({ data }) => {
        let res = data.data;
        delete res.groupOwner;
        console.log("data.data---- ", res);
        that.setState({
          isGroupArchived: true,
          group: { ...group, ...res },
          preventCreate: false,
        });
        that.props.updateGroupSettings(res);
      });
  };

  render() {
    let {
      name,
      invitedUsers,
      users,
      preventCreate,
      showGrpMenu,
      isOpen,
      group,
      groupArchiveModal,
      isGroupArchived,
      currentRole,
      groupLength,
      searchedUser,
    } = this.state;
    let { groupOwner, privacy, createdOn } = group;
    let { user } = this.props;
    let isCreate = (name != "") & (privacy != null) ? true : false;
    // console.log('invitedUsers: ', invitedUsers)
    let grp_img =
      group && group.bannerImg && group.bannerImg.url
        ? group.bannerImg.url
        : grpBannerImg;

    return (
      <div className="boxShadow1 mobile-single-group-header-wrapper">
        <div className="">
          <div className="">
            <img
              src={grp_img}
              className={`grp_single_page_cover_img ${
                group && group.bannerImg && group.bannerImg.url
                  ? ""
                  : "grp_img_border_bottom"
              }`}
            />
          </div>
          <h4
            className={`text-center font-weight-bold`}
            onClick={() => this.grpHomePage()}
          >
            {group.name}
          </h4>
          <div className="grp_create_page_group_status text-center">
            {" "}
            {privacy != null
              ? groupContentFields(privacy)["name"]
              : "Group Status"}
            <span
              className="grp_create_page_member_count"
              onClick={() => this.goToMembersPage()}
            >
              {" "}
              {groupLength} members
            </span>
            <span className={`grp_page_fdate text-center`}>
              Started on {moment(createdOn).format("MMM Do, YYYY")}
            </span>
          </div>{" "}
          <div className="mb-2">
            {(group && group.categories.length > 0) ||
            (group &&
              group.groupOwner &&
              group.groupOwner._id == user.profile._id) ? (
              <div className="mb-0 d-block">
                <span className="grp-cat-mobile-header">
                  {group && group.categories.length > 0 ? (
                    group.categories.map((e, idx) => {
                      return (
                        <span
                          className="grp-mobile-cat"
                          style={{
                            paddingRight:
                              e._id == "template_other_01" ? "0px" : "",
                          }}
                          key={idx}
                        >
                          <span
                            className="grp_story_template"
                            style={{
                              backgroundColor: groupERGcategories.filter(
                                g => g.id == e.id
                              )[0].color,
                              border: groupERGcategories.filter(
                                g => g.id == e.id
                              )[0].border,
                            }}
                          >
                            <img src={e.image} className="grp_template_image" />
                            {e.name}
                          </span>
                        </span>
                      );
                    })
                  ) : (
                    <span className="go_to_grp_settings">
                      Please go to{" "}
                      <span
                        className="go_to_grp_settings_btn"
                        onClick={() => this.goToPage("ST")}
                      >
                        Group Settings
                      </span>{" "}
                      to select categories.
                    </span>
                  )}
                </span>
              </div>
            ) : null}
          </div>
          <div className="text-center">
            {!showGrpMenu &&
            groupRolePriviledge({
              role: currentRole,
              action: 0,
              eventType: "Invite",
              role_priv: [0, 1, 2, 1000],
              group,
            }) ? (
              <div
                className="single_group_menu_invite_members"
                onClick={() => this.setState({ isOpen: true })}
              >
                Invite{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                  <path
                    fillRule="evenodd"
                    d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                  />
                </svg>
              </div>
            ) : null}

            {!showGrpMenu &&
            groupRolePriviledge({
              role: currentRole,
              action: 0,
              comparison: null,
              role_priv: [0, 1, 2, 1000],
              isAdmin: currentRole == 0 || currentRole == 1,
              eventType: "create_event",
              group,
            }) ? (
              <div
                className="single_group_menu_invite_members single_grp_menu_event_btn ml-2"
                onClick={() => this.createGroupEvent()}
              >
                Create Event{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className=""
                  viewBox="0 0 16 16"
                >
                  <path d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z" />
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                </svg>
              </div>
            ) : null}

            <span className="ml-3 mb-2">
              <BiCog
                size={"22px"}
                onClick={() => {
                  if (window.scrollY === 0) {
                    window.scrollTo({ top: 80, behavior: "smooth", left: 0 });
                  }
                  this.toggleMobileOptionsDrawer();
                }}
              />
            </span>
          </div>
          <Drawer
            open={this.state.mobileOptionsDrawerOpen}
            direction={"bottom"}
            onClose={this.toggleMobileOptionsDrawer}
            className="bt-100"
          >
            <div
              className={`mobile-archive-group`}
              onClick={() => {
                this.toggleMobileOptionsDrawer();
                this.toggleMobileGroupInfoModal();
              }}
            >
              <BiInfoCircle size={"24px"} className="mr-2" /> Group Info
            </div>
            {groupRolePriviledge({
              role: currentRole,
              action: 0,
              comparison: "<",
              isAdmin: currentRole == 0 || currentRole == 1,
              group,
            }) ? (
              <Alert
                color="danger"
                className="col-lg-9 col-md-9 groupAlertContainer"
              >
                <span className="alert-info-text">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    className=""
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                  </svg>
                  <span>
                    {groupRoleAlerts({
                      role: currentRole,
                      privacy: group.privacy,
                    })}
                    {group.privacy == "ENTERPRISE" ? (
                      <AddToGroupBtn
                        isSingleGrpMenu={true}
                        incrementMemberCount={this.incrementMemberCount}
                        changeGroupRole={this.changeGroupRole}
                        groupType={currentRole == -1 ? 0 : 1}
                        mod_height={"35px"}
                        item={group}
                      />
                    ) : null}
                  </span>
                </span>
              </Alert>
            ) : group &&
              group.isArchived != true &&
              group.groupOwner &&
              group.groupOwner._id != this.props.user.profile._id ? (
              <AddToGroupBtn
                isSingleGrpMenu={true}
                incrementMemberCount={this.incrementMemberCount}
                changeGroupRole={this.changeGroupRole}
                groupType={currentRole == -1 ? 0 : 1}
                mod_height={"35px"}
                item={group}
              />
            ) : null}
            {(groupOwner &&
              (groupOwner._id == user.profile._id ||
                groupOwner == user.profile._id)) ||
            user.profile.orgAdmin ? (
              <div
                className={`mobile-archive-group`}
                onClick={() => this.showArchiveGroupModal()}
              >
                {isMobile && <span className="mr-2 flaticon-trash"></span>}
                {group.isArchived != true ? "Archive" : "Restore Group"}
                {!isMobile && <span className="ml10 flaticon-trash"></span>}
              </div>
            ) : null}
            <div className="mobile-archive-group">
              <span className="text-info" onClick={() => this.toGroupList()}>
                Back to Groups
              </span>
            </div>
          </Drawer>
          {!showGrpMenu &&
          groupRolePriviledge({
            role: currentRole,
            action: 0,
            eventType: "Invite",
            role_priv: [0, 1, 2, 1000],
            group,
          }) ? (
            <AddMember
              members={this.props.members}
              closeGroupModal={this.closeGroupModal}
              changeMemberLength={this.changeMemberLength}
              isOpen={isOpen}
              group={group}
            />
          ) : null}
        </div>

        <Modal
          isOpen={this.state.mobileGroupInfoModalOpen}
          toggle={this.toggleMobileGroupInfoModal}
        >
          <ModalHeader className={""}>
            <div className="d-flex align-items-center">
              <BiArrowBack
                className="cursor-pointer"
                onClick={this.toggleMobileGroupInfoModal}
              />

              <span className="ml-5">Group Info</span>
            </div>
          </ModalHeader>
          <ModalBody>
            <GroupInfoMobileUI
              {...this.props}
              groupLength={groupLength}
              goToMembersPage={this.goToMembersPage}
              grpHomePage={this.grpHomePage}
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={groupArchiveModal}
          className="single_grp_menu_leave_option dashboardArchiveModalContainer createModalContainer"
        >
          <ModalHeader className="dashboardHeader">
            <div className="dashboardModalTitle">
              {group.isArchived ? "Restore Group" : "Archive Group"}
              <div>"{group.name}"?</div>
            </div>
          </ModalHeader>
          <ModalBody className="dashboardModalBody archiveDashboardModalContent">
            {isGroupArchived ? (
              <span>
                You have {group.isArchived ? "archived" : "restored"} this
                group.
              </span>
            ) : (
              <span>
                You're about to {group.isArchived ? "restore" : "archive"} this
                group.
                {group.isArchived
                  ? " Do you wish to continue?"
                  : "Once a group is archived, only you will be able to access it, but you will not be able to engage with it."}
              </span>
            )}

            <span>
              <div
                className="submitPrivacyContainer archiveBtnContainer"
                style={{ padding: "10px 0px 0px 0px" }}
              >
                {isGroupArchived != true ? (
                  <Button
                    className={`archiveDashboardModalBtn ${
                      preventCreate ? "disabledBtn" : ""
                    }`}
                    onClick={() => this.handleArchiveGroup({ value: 3 })}
                  >
                    <span className="">
                      {group.isArchived != true ? "Archive" : "Restore Group"}
                      <span className="ml10 flaticon-trash"></span>
                    </span>
                  </Button>
                ) : null}

                <Button
                  outline
                  color="secondary"
                  className="cancelDashboardModalBtn"
                  onClick={() => this.setState({ groupArchiveModal: false })}
                >
                  <span className="">Close</span>
                </Button>
              </div>
            </span>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(SingleGroupHeaderMobile, axios)));
